import React, { useEffect, useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

interface IMTabsProps {
  tabs: string[];
  setActiveTab: (value: number) => void;
  customTabStyle?: any;
}

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const MTabs: React.FunctionComponent<IMTabsProps> = ({
  tabs,
  setActiveTab,
  customTabStyle,
}) => {
  const [value, setValue] = useState<number>();

  useEffect(() => {
    if (value !== undefined) setActiveTab(value);
  }, [value]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (tabs.length) {
      setValue(0);
    }
  }, [tabs]);

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <AppBar
        position="static"
        sx={{
          boxShadow: 'none',
        }}
      >
        <Tabs
          value={value ?? 0}
          onChange={handleChange}
          TabIndicatorProps={{
            style: {
              ...(customTabStyle?.tabIndicatorProp || {}),
            },
          }}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          sx={{
            backgroundColor: 'primary.main',
            display: 'flex',
            '& .MuiTabs-flexContainer': {
              flexGrow: 1,
            },
            '& .MuiTab-root': {
              flex: 1,
            },
            '& .MuiTabs-indicator': {
              height: '1px',
            },
            ...(customTabStyle?.parentTabProp || {}),
          }}
          scrollButtons={false}
          aria-label="scrollable prevent tabs example"
        >
          {tabs.map((tab, index) => (
            <Tab
              key={`tab-${String(index)}`}
              label={tab}
              {...a11yProps(index)}
              sx={{
                backgroundColor: '#ffffff',
                color:
                  value === index
                    ? customTabStyle?.childActiveTabColor || 'secondary.main'
                    : '#000000',
                fontWeight: value === index ? '600' : '500',
                textTransform: 'none',
                padding: '0px 12px',
                ...(customTabStyle?.childTabProp || {}),
              }}
            />
          ))}
        </Tabs>
      </AppBar>
    </Box>
  );
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#F0F5FB',
    },
    secondary: {
      main: '#537C5B',
    },
  },
});

const App: React.FunctionComponent<IMTabsProps> = ({
  tabs,
  setActiveTab,
  customTabStyle,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <MTabs
        tabs={tabs}
        setActiveTab={setActiveTab}
        customTabStyle={customTabStyle}
      />
    </ThemeProvider>
  );
};

export default App;
